import { defineStore } from "pinia"
import { ref } from "vue"

export const useMsgStore = defineStore("msgStore", () => {
  const totalPages = ref({})
  totalPages.value.home1 = {
    'name': '万事胜意',
    'path': '/overt/welcome/home1',
    'items': [
      {
        'name': '导航指南',
        'path': '/overt/welcome/home1',
        'desc': '时间就像海绵里面的水,挤挤总会有的.',
        'thumbnail': 'images/home2.jpg',
        'items': [
          { 'name': '小林通', 'url': 'https://lnlin.com' },
        ],
      },
      {
        'name': '极简主义',
        'path': '/overt/welcome/home1',
        'desc': '弄清自己想要什么,放弃一些无关紧要的事情.',
        'thumbnail': 'images/home1.jpg',
        'items': [
          { 'name': '断舍离', 'path': '/overt/welcome/home1' },
          { 'name': '清单表', 'path': '/overt/welcome/home1' },
        ],
      },
    ]
  }

  totalPages.value.home2 = {
    'name': '赛博朋克',
    'path': '/overt/welcome/home2',
    'items': [
      {
        'name': '蒸汽机械',
        'path': '/overt/welcome/home2',
        'desc': '发挥想象力,结合AI做一些简单有趣的小工具.',
        'thumbnail': 'images/home2.jpg',
        'items': [
          { 'name': '贾维呱', 'path': '/overt/welcome/home2' },
        ],
      },
      {
        'name': '廿四节气',
        'path': '/overt/welcome/home2',
        'desc': '偶尔灵光一闪的想法,收集一些异想天开的脑洞.',
        'thumbnail': 'images/home3.jpg',
        'items': [
          { 'name': '惊蛰', 'path': '/overt/welcome/home2' },
          { 'name': '谷雨', 'path': '/overt/welcome/home2' },
          { 'name': '立秋', 'path': '/overt/welcome/home2' },
        ],
      },
    ]
  }

  totalPages.value.home3 = {
    'name': '星辰大海',
    'path': '/overt/welcome/home3',
    'items': [
      {
        'name': '独立开发',
        'path': '/overt/welcome/home3',
        'desc': '不会偷懒的开发不是好开发,一键自动化单元测试和远程操作.',
        'thumbnail': 'images/home1.jpg',
        'items': [
          { 'name': '服务监控', 'path': '/overt/welcome/home3' },
          { 'name': '操作面板', 'path': '/overt/welcome/home3' },
        ],
      },
      {
        'name': '万物互联',
        'path': '/overt/welcome/home3',
        'desc': '不搞硬件的开发不是好开发,用程序来服务现实的生活.',
        'thumbnail': 'images/home2.jpg',
        'items': [
          { 'name': '天猫精灵', 'path': '/overt/welcome/home3' },
          { 'name': '自定义路由', 'path': '/overt/welcome/home3' },
        ],
      },
      {
        'name': '产品原型',
        'path': '/overt/welcome/home3',
        'desc': '不做产品的开发不是好开发,做一款好产品是程序员的终极梦想.',
        'thumbnail': 'images/home3.jpg',
        'items': [
          { 'name': '虚拟现实', 'path': '/overt/welcome/home3' },
        ],
      },
      {
        'name': '交互设计',
        'path': '/overt/welcome/home3',
        'desc': '不懂设计的开发不是好开发,要懂一点动态交互和界面设计.',
        'thumbnail': 'images/home4.jpg',
        'items': [
          { 'name': 'UX交互', 'path': '/overt/welcome/home3' },
          { 'name': 'UI设计', 'path': '/overt/welcome/home3' },
        ],
      },
    ]
  }

  totalPages.value.home4 = {
    'name': '平安喜乐',
    'path': '/overt/welcome/home4',
    'items': [
      {
        'name': '不烦世事',
        'path': '/overt/welcome/home4',
        'desc': '记录一些过去的片段和有趣的事情.',
        'thumbnail': 'images/home1.jpg',
        'items': [
          { 'name': '备忘录', 'path': '/overt/welcome/home4' },
        ],
      },
    ]
  }

  totalPages.value.home5 = {
    'name': '梦想成真',
    'path': '/overt/welcome/home5',
    'items': [
      {
        'name': '新年愿望',
        'path': '/overt/welcome/home5',
        'desc': '做一个能把想法变成现实的创意实现者.',
        'thumbnail': 'images/home1.jpg',
        'items': [
          { 'name': '星球计划', 'path': '/overt/welcome/home5' },
        ],
      },
    ]
  }

  return {
    totalPages
  }
})